<template>
  <b-collapse
    :id="'technical-info-' + result._id"
    :visible="visible"
    @show="on_show"
  >
    <b-overlay :show="loading">
      <div class="product-technical-info">
        <h4 class="title" v-if="!hideTitle">Technical Details</h4>
        <b-row>
          <b-col class="product-technical-info-field">
            <h4>Origin</h4>
            - {{ result._source.Country[0] }} - {{ result._source.Region[0] }}
          </b-col>
        </b-row>
        <b-row>
          <b-col class="product-technical-info-field">
            <h4>Producer</h4>
            - <a :href="info.producer_link">{{ result._source.Producer[0] }}</a>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            class="product-technical-info-field"
            v-if="result._source.Closure"
          >
            <h4>Closure</h4>
            - {{ result._source.Closure }}
          </b-col>
          <b-col
            class="product-technical-info-field"
            v-if="result._source.CaseSize"
          >
            <h4>Case Size</h4>
            - {{ result._source.CaseSize }}
          </b-col>
        </b-row>
        <b-row>
          <b-col
            class="product-technical-info-field"
            v-if="result._source.Style"
          >
            <h4>Style</h4>
            - {{ result._source.Style.split("|").join(" | ") }}
          </b-col>
        </b-row>
        <b-row>
          <b-col
            class="product-technical-info-field"
            v-if="result._source.OrganicStatus[0]"
          >
            <h4>Organic Status</h4>
            - {{ result._source.OrganicStatus[0] }}
          </b-col>
          <b-col
            class="product-technical-info-field"
            v-if="result._source.Allergens"
          >
            <h4>Allergens</h4>
            - {{ result._source.Allergens }}
          </b-col>
        </b-row>
        <b-row>
          <b-col
            class="product-technical-info-field"
            v-if="result._source.VeganVeg"
          >
            <h4>Vegetarian / Vegan</h4>
            - {{ result._source.VeganVeg }}
          </b-col>
        </b-row>
        <b-row>
          <b-col
            class="product-technical-info-field"
            v-if="result._source.GrapeVarietyText"
          >
            <h4>Grape Variety</h4>
            -
            <b-link
              :href="
                '/buy-wine/-/grape-variety/' + result._source.GrapeVariety[0]
              "
              >{{ result._source.GrapeVarietyText }}</b-link
            >
          </b-col>
        </b-row>
        <b-row>
          <b-col
            class="product-technical-info-section"
            v-if="info.producer_note"
          >
            <h4>Producer</h4>
            <div v-html="info.producer_note"></div>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="product-technical-info-section" v-if="info.winemaking">
            <h4>Winemaking</h4>
            <div v-html="info.winemaking"></div>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            class="product-technical-info-section"
            v-if="info.tasting_note"
          >
            <h4>Tasting Note</h4>
            <div v-html="info.tasting_note"></div>
          </b-col>
        </b-row>
      </div>
    </b-overlay>
  </b-collapse>
</template>

<script>
import jbs_api from "@/modules/jbs-api";

export default {
  props: {
    result: {
      type: [Boolean, Object],
      default: false,
    },
    visible: {
      type: [Boolean],
      default: false,
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      info: false,
    };
  },
  mounted() {
    if (this.visible) {
      this.loading = true;
      this.fetch_info();
    }
  },
  methods: {
    on_show() {
      if (!this.info) {
        this.loading = true;

        this.fetch_info();
      }
    },
    fetch_info() {
      jbs_api
        .get("product-information", { params: { id: this.result._id } })
        .then((response) => {
          this.info = response.data;
          this.loading = false;
        });
    },
  },
};
</script>
